import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAuthState } from '../../models/auth-state.model';
import * as AuthActions from 'src/app/store/actions/auth.actions';

const USER_SESSION_KEY = 'userSession';

export interface UserSession {
    Token: string;
    UserID: number;
    Username: string;
    Email: string;
    IsAdmin?: boolean;
    RequiresPasswordChange?: boolean;
}

@Injectable({ providedIn: 'root' })
export class SessionManagerService {
    constructor(private store: Store<{ auth: IAuthState }>) {}

    getUserSession(): UserSession | null {
        const session = localStorage.getItem(USER_SESSION_KEY);
        return session ? JSON.parse(session) : null;
    }

    setUserInLocalStorage(user: UserSession): void {
        localStorage.setItem(USER_SESSION_KEY, JSON.stringify(user));
    }

    setCurrentUser(user: UserSession | null): void {
        this.store.dispatch(AuthActions.setCurrentUser({ user }));
    }

    removeCurrentUser(): void {
        localStorage.removeItem(USER_SESSION_KEY);
        this.store.dispatch(AuthActions.setCurrentUser({ user: null }));
    }
}
